import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./i18n/index.js";
import App from "./App.jsx";
import { UserProvider } from "./contexts/UserContext.jsx";
import { ToastMessageProvider } from "./contexts/ToastMessageContext.jsx";
import { registerSW } from 'virtual:pwa-register';
import {
  initAdminUpdateDetection,
  notifyAdminUpdateAvailable,
} from './utils/adminUpdateNotifier.js';
import "./index.css";

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    window.__adminApplySWUpdate = () => updateSW(true);
    notifyAdminUpdateAvailable({ source: 'service-worker', version: 'pending' });
  },
  onOfflineReady() {
    console.log('Admin app ready to work offline');
  },
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return;
    // Keep SW fresh so deploy is detected while the tab stays open
    setInterval(() => {
      registration.update().catch(() => {});
    }, 30 * 1000);
  },
});
window.__adminApplySWUpdate = () => updateSW(true);

if (import.meta.env.PROD) {
  initAdminUpdateDetection();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <UserProvider>
      <ToastMessageProvider>
        <App />
      </ToastMessageProvider>
    </UserProvider>
  </BrowserRouter>
);